import Text from '@components/common/text';
import CustomImage from '@components/common/image';
import Icon from '@components/common/assets';
import ApplyModals from '@components/mypage/common/modalsWrap';
import { useRecruitmentUrl } from '@repository/recruitment/useRecruitment';
import { useWritingResumePositions } from '@repository/match';
import { useInsightAceessToken } from '@repository/insight/useInsight';
import ApplyBtn from './applyBtn';
import MatchingHomePositionCardVO from '@domain/vo/match/ApplicationPositionVO';

import { dummyImgSrc } from '@domain/constant/img/positionDummyImgSrc';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import { PageTypeEnum } from '@domain/constant/match/profile/pageType';
import useMessageModal from '@utils/hooks/useMessageModal';
import useModals from '@utils/hooks/useModals';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface ItemProps {
  data: MatchingHomePositionCardVO;
}

const Item = ({ data }: ItemProps) => {
  const { positionSn, companyName, positionName, positionType, enableInsightMypage, matchingOfferYn, closingDateTime } =
    data;
  const { refetch } = useWritingResumePositions({ enabled: false });
  const { mutateAsync: fetchInsightAccessToken } = useInsightAceessToken();
  const { mutateAsync: fetchRecruitmentDomain } = useRecruitmentUrl();

  const { openMessageModal } = useMessageModal();
  const isJobdaPosition = positionType === 'JOBDA';

  const { openModal, modalState, closeModal } = useModals([
    'RESUME_DELETE',
    'RESUME_SAVE',
    'APPLY_CANCEL',
    'RESUME_END',
    'POSITION_END',
  ] as const);

  const onClickCard = () => {
    if (isJobdaPosition) onOpenMessage();
    else handleInsightCard();
  };

  const handleInsightCard = async () => {
    if (enableInsightMypage) {
      const { accessToken } = await fetchInsightAccessToken();
      const { url } = await fetchRecruitmentDomain({ positionSn, pageType: PageTypeEnum.RESUME_WRITING });
      const editResumeUrl = url.replace('registResume', 'modifyResume') + `&accessToken=${accessToken}`;
      window.open(editResumeUrl);
    } else openModal('POSITION_END');
  };

  const onOpenMessage = () => {
    openMessageModal(positionSn);
  };

  const { text, color } = (() => {
    let text = '상시 채용';
    let color = Colors.C_COOL_GRAY_90;

    if (!closingDateTime) return { text, color };

    switch (Math.sign(Number(closingDateTime))) {
      case 0: {
        text = 'D-day';
        break;
      }
      case 1: {
        text = `D-${closingDateTime}`;
        break;
      }
      case -1: {
        text = '포지션 마감';
        color = Colors.C_COOL_GRAY_60;
        break;
      }
    }

    return { text, color };
  })();

  return (
    <>
      <button className={cx('wrapper')} onClick={onClickCard}>
        <div className={cx('column', 'column1')}>
          <CustomImage
            className={cx('img')}
            src={data.companyLogoUrl ?? dummyImgSrc}
            alt="companyLogo"
            width={48}
            height={48}
            ErrorImage={
              <CustomImage className={cx('img')} src={dummyImgSrc} alt="companyLogo" width={48} height={48} />
            }
          />
          <div className={cx('infoArea')}>
            <div className={cx('positionName')}>
              {matchingOfferYn && (
                <Text fontStyle={FontStyle.B3P_B} color={Colors.C_GREEN_200}>
                  매칭 제안
                </Text>
              )}
              <Text fontStyle={FontStyle.B3P_B} ellipsis styles={{ maxWidth: 582 }}>
                {positionName}
              </Text>
              {positionType === 'HOMEPAGE' && (
                <Icon name="openInNewLight" width={24} height={24} fill={Colors.C_COOL_GRAY_60} />
              )}
            </div>
            <Text fontStyle={FontStyle.B4P_M} color={Colors.C_COOL_GRAY_70}>
              {companyName}
            </Text>
          </div>
        </div>

        <div className={cx('column', 'column2')} style={{ color }}>
          <Text fontStyle={FontStyle.B3_M}>{text}</Text>
        </div>

        <ApplyBtn statusType={data.jobApplicationProcessType} openModal={openModal} />
      </button>

      <ApplyModals
        positionSn={positionSn}
        modalState={modalState}
        onClose={closeModal}
        openModal={openModal}
        confirmAfter={refetch}
      />
    </>
  );
};

export default Item;
